import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'outboundCalls',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Outbound Calls',
  },
}

const keys = {
  statKey: 'outbound_calls',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const outboundCalls = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { outboundCalls }
